import * as React from "react";
import { observer } from "mobx-react-lite";
import { message } from "antd";
import UsersManagerStore from "../stores/UsersManagerStore";
import { ProjectsAssignmentTable } from "./ProjectsAssignmentTable";
import AppModal from "../../common/components/AppModal";

type Props = {
    store: UsersManagerStore;
};

export const EditProjectAssignmensDialog: React.FC<Props> = observer(
    ({ store }) => {
        const handleCancel = () => {
            store.clearEditableProjects();
            store.setIsProjectRolesDialogVisible(false);
        };

        const handleSubmit = () => {
            if (store.editableProjectsForUser.length === 0) {
                message.error("Please select at least one project");
                return;
            }
            store
                .updateUserAssignments()
                .then(() => store.clearEditableProjects());
        };

        return (
            <AppModal
                open={store!.isEditProjectsRolesDialogVisible}
                onCancel={() => store.setIsProjectRolesDialogVisible(false)}
                maskClosable={false}
                closable={false}
                title="Project assignments"
                destroyOnClose
                width={700}
                centered
                className="alpha-modal"
                cancelButtonTitle="Cancel"
                onCancelClick={handleCancel}
                submitButtonTitle="Save"
                onSubmitClick={handleSubmit}
                submitButtonProps={{
                    loading: store.tableIsLoading,
                }}
            >
                <ProjectsAssignmentTable store={store} />
            </AppModal>
        );
    },
);
export default EditProjectAssignmensDialog;
